import React from 'react'
import {Component} from 'react'
import './location-selector.scss'

class Location extends Component {
  get className(){
    let classes = ["location-selector__location"]
    if( this.props.current ) classes.push( 'location-selector__location--current' )
    return classes.join( ' ' )
  }
  render(){
    let l = this.props.location
    return (
      <li
      className={this.className}
      onClick={ ()=>{ this.props.setLocation(l) } }
      >
        {l.name}
      </li>
    )
  }
}

export default class extends Component {
  render(){
    return (
      <ul className="location-selector">
        {
          this.props.locations.map( (l,i) => {
            let current = ( this.props.currentLocation && this.props.currentLocation.id == l.id )
            return <Location current={current} setLocation={this.props.setLocation} key={i} location={l} />
          } )
        }
      </ul>
    )
  }
}
